import React from 'react'
import { Explorer, /* LogoMarque */ } from '../components'
import styles from './section-map.module.css'
import copy from '../../../database/pages/home.json'
import { LogoSlider } from './logo-slider'

const SectionMap = () => {
  return (
    <div
      className="pt-20 pb-16 lg:pb-32 lg:pt-24"
      style={{backgroundColor: '#D4E2E6'}}
    >
      <div className="container mx-auto overflow-x-hidden">
        {/* <LogoMarque /> */}
        <LogoSlider />

        <div className="mb-8 lg:w-10/12 lg:mx-auto">
          <p className={`text-center font-semibold ${styles['section-map__title']}`}>
            {copy.mapSectionBlurb}
          </p>
        </div>

        <Explorer />

        {/* <div className="text-center">
          <Link to="/program">
            <p className="button-outline font-accent w-full lg:w-40">Explore More</p>
          </Link>
        </div> */}
      </div>
    </div>
  )
}

export { SectionMap }
